import { jsx as _jsx } from "react/jsx-runtime";
import styles from '../ui/styles.module.scss';
export function getErrorMessages(errors, t) {
    return (_jsx("ul", { className: styles.list, children: errors.map((errorItem, idx) => (_jsx("li", { children: t(errorItem.message) }, idx))) }));
}
